import env from './dev';

export default {
  // 获取国家ID，主要为了三个环境返回不同的国家ID
  envCountryIdMap: {
    cambodia: {
      prod: 10010,
      test: 10009,
      dev: 10009,
    },
    america: {
      dev: 10011,
      test: 10011,
      prod: 10016,
    },
    canada: {
      dev: 10020,
      test: 10020,
      prod: 10023,
    },
  },
  getCountryId(countryKey) {
    return this.envCountryIdMap[countryKey][env || 'prod'];
  },
};
